import React, { useEffect } from 'react';
import { useFormData } from '../context/FormDataContext';
import { CompleteFormData, FormDataSnapshot } from '../types/formTypes';

interface FormDataTrackerProps {
  form: CompleteFormData;
  onFormDataUpdate: (formId: string, snapshot: FormDataSnapshot) => void;
}

const FormDataTracker: React.FC<FormDataTrackerProps> = ({ form, onFormDataUpdate }) => {
  const { fields } = useFormData();

  useEffect(() => {
    const snapshot: FormDataSnapshot = {
      form_id: form.form_id,
      form_name: form.form_name,
      description: form.description,
      fields: fields,
    };

    onFormDataUpdate(form.form_id, snapshot);
  }, [fields, form.form_id, form.form_name, form.description, onFormDataUpdate]);

  return null;
};

export default FormDataTracker;

